import {SxProps, Theme, useTheme} from '@mui/material';
import {useCallback} from 'react';
import {ContractStatusEnum} from 'src/enums';
import {UserTypeEnum} from 'src/enums/common';

export const useSxValue = (label: string): SxProps<Theme> => {
    const theme = useTheme();
    const sxValueCallback = useCallback(
        (theme: Theme): SxProps<Theme> => {
            switch (label) {
                case UserTypeEnum.BUSINESS:
                    return {
                        background: theme.palette.warning.light,
                        color: theme.palette.warning.dark,
                    };
                case UserTypeEnum.COMPANY:
                    return {
                        background: '#E6E6FE',
                        color: '#6950DB',
                    };
                case UserTypeEnum.EMPLOYEE:
                    return {
                        background: theme.palette.neutral[100],
                        color: theme.palette.neutral[700],
                    };
                case UserTypeEnum.PRIVATE_DRIVER:
                case 'ACTIVATED':
                    return {
                        background: theme.palette.success.light,
                        color: theme.palette.success.dark,
                    };
                case UserTypeEnum.SUPER_ADMIN:
                    return {
                        background: theme.palette.brand.light,
                        color: theme.palette.brand.dark,
                    };
                case UserTypeEnum.TECHNICAL_MANAGER:
                    return {
                        background: theme.palette.alternative[50],
                        color: theme.palette.alternative[700],
                    };
                case UserTypeEnum.SALES_MANAGER:
                    return {
                        background: theme.palette.secondaryColor[50],
                        color: theme.palette.secondaryColor[700],
                    };
                case UserTypeEnum.CLIENT_MANAGER:
                    return {
                        background: theme.palette.primaryColor[50],
                        color: theme.palette.primaryColor[700],
                    };
                case ContractStatusEnum.OPERATION:
                    return {
                        background: theme.palette.primaryColor[100],
                        color: theme.palette.primary.dark,
                    };
                case ContractStatusEnum.INSTALLATION:
                    return {
                        background: theme.palette.success.light,
                        color: theme.palette.success.dark,
                    };
                case ContractStatusEnum.WAIT_FOR_SIGNATURE:
                    return {
                        background: theme.palette.warning.light,
                        color: theme.palette.warning.dark,
                    };
                // A business-defined role name lands here, and that is fine: a neutral chip that
                // reads correctly is a better answer than a colour keyed to a name nobody can predict.
                // The known names above keep their established colours so nothing shifts for anyone.
                default:
                    return {
                        background: theme.palette.neutral[300],
                        color: theme.palette.neutral[700],
                    };
            }
        },
        [label]
    );
    return sxValueCallback(theme);
};
